import { useEffect, useRef } from 'react';
import { LIVE_NOW_COLOR, LIVE_NOW_TINT } from '@/components/LiveNowLine';

/**
 * The Manning Stats text, with the block for the current time highlighted.
 * A block is the "HHMM: nn/nn" line plus the zone line under it. Plain text when
 * `marker` is null, so the copied text (which comes from the string itself) is
 * unchanged either way.
 */
export function LiveStatsText({ text, marker }: { text: string; marker: string | null }) {
  const liveRef = useRef<HTMLSpanElement>(null);
  useEffect(() => {
    // Keep the live block in view inside the stats pane only — block:'nearest'
    // and no page scroll, so it never yanks the roster around.
    const el = liveRef.current;
    const box = el?.parentElement;
    if (!el || !box || box.scrollHeight <= box.clientHeight) return;
    box.scrollTop = Math.max(0, el.offsetTop - box.offsetTop - 4);
  }, [marker]);

  if (!marker) return <>{text}</>;
  const lines = text.split('\n');
  const out: React.ReactNode[] = [];
  let i = 0;
  while (i < lines.length) {
    const m = lines[i].match(/^(\d{4}):/);
    if (m && m[1] === marker) {
      out.push(
        <span
          key={`live-${i}`}
          ref={liveRef}
          style={{ display: 'block', background: LIVE_NOW_TINT, borderLeft: `3px solid ${LIVE_NOW_COLOR}`, paddingLeft: 4, fontWeight: 700 }}
        >
          {lines[i]}{'\n'}{lines[i + 1] ?? ''}{' ◀ now'}
        </span>,
      );
      i += 2;
      continue;
    }
    out.push(lines[i] + (i < lines.length - 1 ? '\n' : ''));
    i++;
  }
  return <>{out}</>;
}
